import { useQuery, type UseQueryResult } from '@zg-rentals/react-query5';
import { RentalManagerUserFreemiumV2WebApiHandler_charge } from '@zg-rentals/ts-rental-manager-api-client';
import { getClient } from '@zg-rentals/ts-rental-manager-api-client/client';
import type {
  FreemiumChargeV2ResponseWebDto,
  ListingAlias,
  RentalManagerPaymentProductType,
} from '@zg-rentals/ts-rental-manager-api-client';
import type { DatarouterError } from '@zg-rentals/web-base';

type UseChargeParams = {
  hostApp?: string;
  listingAlias: ListingAlias;
  productType: RentalManagerPaymentProductType;
};

const useCharge = (queryParams: UseChargeParams): UseQueryResult<FreemiumChargeV2ResponseWebDto, DatarouterError> => {
  const { listingAlias, productType, hostApp } = queryParams;

  const queryFn = () =>
    RentalManagerUserFreemiumV2WebApiHandler_charge(
      { listingAlias, productType, hostApp },
      getClient()?.extend({ timeout: 5 * 60 * 1000 }),
    );

  const queryHook = useQuery<FreemiumChargeV2ResponseWebDto, DatarouterError>({
    queryKey: ['useCharge', listingAlias],
    queryFn,
    enabled: false,
    staleTime: 0,
    retry: 0,
    meta: {
      tags: ['freemium-charge'],
      context: {
        api: 'rental-manager',
        details: 'Charging freemium listing',
      },
    },
  });

  return queryHook;
};

export { useCharge };
